export default {"src":"https://fishbrain.com/_next/static/media/iowa.3192e3e8.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};